import React from "react";

import cx from "classnames";
import { isSameDay } from "date-fns";

import styles from "./Header.module.css";

export interface HeaderProps {
	date: Date;
	getNow: () => Date;
	showDay: boolean;
}

export default function Header({ date, getNow, showDay = false }: HeaderProps) {
	const { isHighlighted, day, weekday } = React.useMemo(() => {
		const now = getNow();
		const isHighlighted = isSameDay(date, now);
		const { day, weekday } = new Intl.DateTimeFormat("en-US", { weekday: "short", day: "numeric" })
			.formatToParts(date)
			.reduce(
				// .formatToParts() returns an array
				// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts#description
				(acc, part) => ({ ...acc, [part.type]: part.value }),
				{} as { day: string; weekday: string },
			);

		return { isHighlighted, day, weekday };
	}, [date, getNow]);

	return (
		<span className={styles.header} role="columnheader" aria-sort="none">
			<span className={cx(styles.weekday, { [styles.isToday]: isHighlighted && showDay })}>{weekday}</span>
			{showDay && <span className={cx(styles.day, { [styles.isToday]: isHighlighted })}>{day}</span>}
		</span>
	);
}
